import { Component, Input } from '@angular/core';
import { SortDirection, SortEvent } from '@aposin/ng-aquila/table';
import { SharedModule } from '@shared/shared.module';

@Component({
  selector: 'app-cn-history-table',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './cn-history-table.component.html',
  styleUrl: './cn-history-table.component.scss'
})
export class CnHistoryTableComponent {
  @Input() approvalDetailCoverNoteHistory: any;

  async sortTable(sort: SortEvent, tableName: string) {
    let abc = this[tableName];
    this[tableName] = await abc?.slice()?.sort((current, previous) => {
      return this.compare(current[sort.active], previous[sort.active], sort.direction);
    });
  }

  compare(a, b, direction: SortDirection) {
    const isEmpty = v => v === null || v === undefined || v === '';

    if((isEmpty(a) && isEmpty(b)) || (a == b)) {
      return 0;
    }

    if(isEmpty(a)) {
      return direction === 'asc' ? -1 : 1;
    }

    if(isEmpty(b)) {
      return direction === 'asc' ? 1 : -1;
    }

    return (a < b ? -1 : 1) * (direction === 'asc' ? 1 : -1);
  }
}
